import { all } from 'redux-saga/effects';

import createVacancyWatcher from './create-vacancy';
import createVacancyGroupWatcher from './create-vacancy-group';
import deleteVacancyGroupWatcher from './delete-vacancy-group';
import documentsWatcher from './documents-saga';
import editVacancyWatcher from './edit-vacancy';
import editVacancyGroupWatcher from './edit-vacancy-group';
import getAdminVacanciesWatcher from './get-admin-vacancies';
import getCatalogFiltersWatcher from './get-catalog-filters';
import getCatalogVacanciesWatcher from './get-catalog-vacancies';
import getCityWatcher from './get-city';
import getDivisionWatcher from './get-division';
import getGroupsVacansyWatcher from './get-group-vacancy';
import getMainPageWatcher from './get-main-page';
import getMoreNewsWatcher from './get-more-news-on-page';
import getNewsInformationWatcher from './get-news-division';
import getNewsWatcher from './get-news-on-page';
import getOfficePageWatcher from './get-office-page';
import getOneResponseWatcher from './get-one-response';
import getOperationsPageWatcher from './get-operations-page';
import getOthersVacanciesWatcher from './get-others-vacancies';
import getPossibleResponsibleUsersWatcher from './get-possible-responsible-users';
import getRoleWatcher from './get-role';
import getTechPageWatcher from './get-tech-page';
import getVacancyWatcher from './get-vacancy';
import getVacancyGroupWatcher from './get-vacancy-group';
import getVacansyResponsesWatcher from './get-vacancy-responses';
import openSearchWatcher from './open-search';
import searchVacanciesWatcher from './search-vacancies';
import searchVacancyGroupWatcher, { searchVacancyWatcher } from './search-vacancy-group';
import setSearchValueWatcher from './set-search-value';
import getViewedStatusWatcher from './set-viewed-status-responses';
import vacanciesWatcher from './vacancies-saga';
import vacancyRecommendationWatcher from './vacancy-recommendation';
import vacancyResponseWatcher from './vacancy-response';

export default function* rootSaga() {
  yield all([
    searchVacanciesWatcher(),
    getVacancyWatcher(),
    vacancyResponseWatcher(),
    vacancyRecommendationWatcher(),
    openSearchWatcher(),
    searchVacancyGroupWatcher(),
    setSearchValueWatcher(),
    searchVacancyWatcher(),
    documentsWatcher(),
    getCatalogFiltersWatcher(),
    getCatalogVacanciesWatcher(),
    getCityWatcher(),
    getRoleWatcher(),
    createVacancyWatcher(),
    getVacancyGroupWatcher(),
    editVacancyGroupWatcher(),
    createVacancyGroupWatcher(),
    getAdminVacanciesWatcher(),
    getOthersVacanciesWatcher(),
    editVacancyWatcher(),
    deleteVacancyGroupWatcher(),
    getDivisionWatcher(),
    getGroupsVacansyWatcher(),
    getPossibleResponsibleUsersWatcher(),
    getVacansyResponsesWatcher(),
    getViewedStatusWatcher(),
    getOneResponseWatcher(),
    vacanciesWatcher(),
    getMainPageWatcher(),
    getOfficePageWatcher(),
    getOperationsPageWatcher(),
    getTechPageWatcher(),
    getNewsWatcher(),
    getMoreNewsWatcher(),
    getNewsInformationWatcher(),
  ]);
}
